
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.98 3a1 1 0 011 1.014v16a1 1 0 01-1 1 1.06 1.06 0 01-.57-.17L7 16.444H2a1 1 0 01-1-1v-6.86a1 1 0 011-1h5l6.48-4.45a1 1 0 01.5-.134zm-1 2.914l-5.1 3.5a1 1 0 01-.57.17H2.98v4.86h4.33a1 1 0 01.57.17l5.13 3.52-.03-12.22zm3.974 2.098l.132.005a1 1 0 01.674.367 6 6 0 010 7.26 1 1 0 01-.78.37 1 1 0 01-.78-1.63 4 4 0 000-4.74 1.002 1.002 0 01.886-1.627z"}})])
          )
        }
      }
    